"use strict";

var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");
var _Object$keys = require("@babel/runtime-corejs2/core-js/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");
var _Object$defineProperties = require("@babel/runtime-corejs2/core-js/object/define-properties");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _stringify = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/json/stringify"));
var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));
var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _uuid = _interopRequireDefault(require("uuid"));
var _lodash = require("lodash");
var _webexCore = require("@webex/webex-core");
var _common = require("@webex/common");
var _internalPluginMetrics = require("@webex/internal-plugin-metrics");
var _loggerProxy = _interopRequireDefault(require("../common/logs/logger-proxy"));
var _constants = require("../constants");
var _util = _interopRequireDefault(require("./util"));
var _excluded = ["meeting"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } } // @ts-ignore
// @ts-ignore
/**
 * @class MeetingRequest
 */
var MeetingRequest = exports.default = /*#__PURE__*/function (_StatelessWebexPlugin) {
  (0, _inherits2.default)(MeetingRequest, _StatelessWebexPlugin);
  var _super = _createSuper(MeetingRequest);
  /**
   * Constructor
   * @param {Object} attrs
   * @param {Object} options
   */
  function MeetingRequest(attrs, options) {
    var _this;
    (0, _classCallCheck2.default)(this, MeetingRequest);
    var meeting = attrs.meeting,
      otherAttrs = (0, _objectWithoutProperties2.default)(attrs, _excluded);
    _this = _super.call(this, otherAttrs, options);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "changeVideoLayoutDebounced", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "meetingRef", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "locusDeltaRequest", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "buildLocusDeltaRequestOptions", void 0);
    /**
     * Returns joinCookie from boundedStorage if present.
     * @returns {Object} joinCookie
     */
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getJoinCookie", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var joinCookieRaw, joinCookie;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _this.webex.boundedStorage.get(_constants.REACHABILITY.namespace, _constants.REACHABILITY.localStorageJoinCookie).catch(function () {});
          case 2:
            joinCookieRaw = _context.sent;
            if (!joinCookieRaw) {
              _context.next = 13;
              break;
            }
            _context.prev = 4;
            joinCookie = JSON.parse(joinCookieRaw);
            if (!joinCookie) {
              _context.next = 8;
              break;
            }
            return _context.abrupt("return", joinCookie);
          case 8:
            _context.next = 13;
            break;
          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](4);
            _loggerProxy.default.logger.error("MeetingRequest#constructor --> Error in parsing join cookie data: ".concat(_context.t0));
          case 13:
            return _context.abrupt("return", null);
          case 14:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[4, 10]]);
    })));
    _this.locusDeltaRequest = _util.default.generateLocusDeltaRequest(meeting);
    _this.buildLocusDeltaRequestOptions = _util.default.generateBuildLocusDeltaRequestOptions(meeting);
    _this.changeVideoLayoutDebounced = (0, _lodash.debounce)(_this.changeVideoLayout, 2000, {
      leading: true,
      trailing: true
    });
    return _this;
  }
  (0, _createClass2.default)(MeetingRequest, [{
    key: "joinMeeting",
    value: (
    /**
     * Make a network request to join a meeting
     * @param {Object} options
     * @param {String} options.sipUri
     * @param {String} options.deviceUrl
     * @param {String} options.locusUrl
     * @param {String} options.resourceId,
     * @param {String} options.correlationId
     * @param {boolean} options.ensureConversation
     * @param {boolean} options.moderator
     * @param {boolean} options.pin
     * @param {boolean} options.moveToResource
     * @param {Object} options.roapMessage
     * @param {boolean} options.breakoutsSupported
     * @param {String} options.locale,
     * @param {Array} options.deviceCapabilities
     * @param {boolean} options.liveAnnotationSupported
     * @param {String} options.alias
     * @returns {Promise}
     */
    function () {
      var _joinMeeting = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(options) {
        var asResourceOccupant, inviteeAddress, meetingNumber, permissionToken, deviceUrl, locusUrl, locusClusterUrl, resourceId, correlationId, ensureConversation, moderator, pin, moveToResource, roapMessage, reachability, breakoutsSupported, locale, _options$deviceCapabi, deviceCapabilities, liveAnnotationSupported, clientMediaPreferences, alias, url, body, clusterUrl;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              asResourceOccupant = options.asResourceOccupant, inviteeAddress = options.inviteeAddress, meetingNumber = options.meetingNumber, permissionToken = options.permissionToken, deviceUrl = options.deviceUrl, locusUrl = options.locusUrl, locusClusterUrl = options.locusClusterUrl, resourceId = options.resourceId, correlationId = options.correlationId, ensureConversation = options.ensureConversation, moderator = options.moderator, pin = options.pin, moveToResource = options.moveToResource, roapMessage = options.roapMessage, reachability = options.reachability, breakoutsSupported = options.breakoutsSupported, locale = options.locale, _options$deviceCapabi = options.deviceCapabilities, deviceCapabilities = _options$deviceCapabi === void 0 ? [] : _options$deviceCapabi, liveAnnotationSupported = options.liveAnnotationSupported, clientMediaPreferences = options.clientMediaPreferences, alias = options.alias;
              _loggerProxy.default.logger.info('Meeting:request#joinMeeting --> Joining a meeting', correlationId);
              url = '';
              body = {
                asResourceOccupant: asResourceOccupant,
                device: {
                  url: deviceUrl,
                  // @ts-ignore - config comes from registerPlugin
                  deviceType: this.config.meetings.deviceType
                },
                usingResource: resourceId || null,
                moveMediaToResource: resourceId && moveToResource || false,
                correlationId: correlationId,
                respOnlySdp: true,
                allowMultiDevice: true,
                ensureConversation: ensureConversation || false,
                supportsNativeLobby: 1,
                clientMediaPreferences: clientMediaPreferences
              };
              if (alias) {
                body.alias = alias;
              }
              if (breakoutsSupported) {
                deviceCapabilities.push(_constants.BREAKOUTS.BREAKOUTS_SUPPORTED);
              }
              if (liveAnnotationSupported) {
                deviceCapabilities.push(_constants.ANNOTATION.ANNOTATION_ON_SHARE_SUPPORTED);
              }

              // append installationId to device config if it exists
              // @ts-ignore
              if (this.webex.internal.device.config.installationId) {
                // @ts-ignore
                body.device.installationId = this.webex.internal.device.config.installationId;
              }
              if (locale) {
                body.locale = locale;
              }

              // add deviceCapabilities prop
              if (deviceCapabilities.length) {
                body.deviceCapabilities = deviceCapabilities;
              }
              // @ts-ignore
              if (this.webex.meetings.geoHintInfo) {
                // @ts-ignore
                body.device.countryCode = this.webex.meetings.geoHintInfo.countryCode;
                // @ts-ignore
                body.device.regionCode = this.webex.meetings.geoHintInfo.regionCode;
                body.device.localIp =
                // @ts-ignore
                _internalPluginMetrics.CallDiagnosticUtils.anonymizeIPAddress(this.webex.meetings.geoHintInfo.clientAddress) || undefined;
              }
              if (moderator !== undefined) {
                body.moderator = moderator;
              }
              if (permissionToken) {
                body.permissionToken = permissionToken;
              }
              if (pin !== undefined) {
                body.pin = pin;
              }
              if (!locusUrl) {
                _context2.next = 18;
                break;
              }
              url = "".concat(locusUrl, "/").concat(_constants.PARTICIPANT);
              _context2.next = 35;
              break;
            case 18:
              if (!(inviteeAddress || meetingNumber)) {
                _context2.next = 35;
                break;
              }
              _context2.prev = 19;
              if (!locusClusterUrl) {
                _context2.next = 24;
                break;
              }
              clusterUrl = "https://".concat(locusClusterUrl, "/locus/api/v1");
              _context2.next = 27;
              break;
            case 24:
              _context2.next = 26;
              return this.webex.internal.services.waitForCatalog('postauth');
            case 26:
              // @ts-ignore
              clusterUrl = this.webex.internal.services.get('locus');
            case 27:
              url = "".concat(clusterUrl, "/").concat(_constants.LOCI, "/").concat(_constants.CALL);
              body.invitee = {
                address: inviteeAddress || "wbxmn:".concat(meetingNumber)
              };
              _context2.next = 35;
              break;
            case 31:
              _context2.prev = 31;
              _context2.t0 = _context2["catch"](19);
              _loggerProxy.default.logger.error("Meeting:request#joinMeeting Error Joining ".concat(inviteeAddress || meetingNumber, " --> ").concat(_context2.t0));
              throw _context2.t0;
            case 35:
              // TODO: -- this will be resolved in SDK request
              url = url.concat("?".concat(_constants.ALTERNATE_REDIRECT_TRUE));
              if (resourceId === inviteeAddress) {
                body.callPreferences = {
                  requestedMedia: [_constants._SLIDES_]
                };
              }
              if (roapMessage || reachability) {
                body.localMedias = [{
                  localSdp: (0, _stringify.default)({
                    roapMessage: roapMessage,
                    reachability: reachability
                  })
                }];
              }

              /// @ts-ignore
              return _context2.abrupt("return", this.request({
                method: _constants.HTTP_VERBS.POST,
                uri: url,
                body: body
              }));
            case 39:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[19, 31]]);
      }));
      function joinMeeting(_x) {
        return _joinMeeting.apply(this, arguments);
      }
      return joinMeeting;
    }()
    /**
     * Send a request to refresh the captcha
     * @param {Object} options
     * @param {String} options.captchaRefreshUrl
     * @param {String} options.captchaId
     * @returns {Promise}
     * @private
     */
    )
  }, {
    key: "refreshCaptcha",
    value: function refreshCaptcha(_ref2) {
      var captchaRefreshUrl = _ref2.captchaRefreshUrl,
        captchaId = _ref2.captchaId;
      var body = {
        captchaId: captchaId
      };

      // @ts-ignore
      return this.request({
        method: _constants.HTTP_VERBS.POST,
        uri: captchaRefreshUrl,
        body: body
      }).catch(function (err) {
        _loggerProxy.default.logger.error("Meeting:request#refreshCaptcha --> Error: ".concat(err));
        throw err;
      });
    }

    /**
     * Make a network request to add a dial in device
     * @param {Object} options
     * @param {String} options.correlationId
     * @param {String} options.locusUrl url for the meeting
     * @param {String} options.dialInUrl identifier for the to-be provisioned device
     * @param {String} options.clientUrl identifier for the web device
     * @returns {Promise}
     * @private
     */
  }, {
    key: "dialIn",
    value: function dialIn(_ref3) {
      var locusUrl = _ref3.locusUrl,
        dialInUrl = _ref3.dialInUrl,
        clientUrl = _ref3.clientUrl,
        correlationId = _ref3.correlationId;
      _loggerProxy.default.logger.info('Meeting:request#dialIn --> Provisioning a dial in device', correlationId);
      var uri = "".concat(locusUrl, "/").concat(_constants.PARTICIPANT);
      var body = {
        device: {
          deviceType: _common.deviceType.PROVISIONAL,
          provisionalType: _constants.PROVISIONAL_TYPE_DIAL_IN,
          url: dialInUrl,
          clientUrl: clientUrl
        },
        correlationId: correlationId
      };

      // @ts-ignore
      return this.locusDeltaRequest({
        method: _constants.HTTP_VERBS.POST,
        uri: uri,
        body: body
      }).catch(function (err) {
        _loggerProxy.default.logger.error("Meeting:request#dialIn --> Error provisioning a dial in device, error ".concat(err));
        throw err;
      });
    }

    /**
     * Make a network request to add a dial out device
     * @param {Object} options
     * @param {String} options.correlationId
     * @param {String} options.locusUrl url for the meeting
     * @param {String} options.dialOutUrl identifier for the to-be provisioned device
     * @param {String} options.phoneNumber phone number to dial out to
     * @param {String} options.clientUrl identifier for the web device
     * @returns {Promise}
     * @private
     */
  }, {
    key: "dialOut",
    value: function dialOut(_ref4) {
      var locusUrl = _ref4.locusUrl,
        dialOutUrl = _ref4.dialOutUrl,
        phoneNumber = _ref4.phoneNumber,
        clientUrl = _ref4.clientUrl,
        correlationId = _ref4.correlationId;
      _loggerProxy.default.logger.info('Meeting:request#dialOut --> Provisioning a dial out device', correlationId);
      var uri = "".concat(locusUrl, "/").concat(_constants.PARTICIPANT);
      var body = {
        device: {
          deviceType: _common.deviceType.PROVISIONAL,
          provisionalType: _constants.PROVISIONAL_TYPE_DIAL_OUT,
          url: dialOutUrl,
          dialoutAddress: phoneNumber,
          clientUrl: clientUrl
        },
        correlationId: correlationId
      };

      // @ts-ignore
      return this.locusDeltaRequest({
        method: _constants.HTTP_VERBS.POST,
        uri: uri,
        body: body
      }).catch(function (err) {
        _loggerProxy.default.logger.error("Meeting:request#dialOut --> Error provisioning a dial out device, error ".concat(err));
        throw err;
      });
    }

    /**
     * Sends a requests to get the latest locus DTO, it might be a full Locus or a delta, depending on the url provided
     * @param {Object} options
     * @param {String} options.locusUrl sync url to get ht elatest locus delta
     * @returns {Promise}
     */
  }, {
    key: "getLocusDTO",
    value: function getLocusDTO(options) {
      var url = options.url;
      if (url) {
        // @ts-ignore
        return this.request({
          method: _constants.HTTP_VERBS.GET,
          uri: url
        }).catch(function (err) {
          _loggerProxy.default.logger.error("Meeting:request#getLocusDTO --> Error getting latest locus, error ".concat(err));
          throw err;
        });
      }
      return _promise.default.reject();
    }

    /**
     * Make a network request to make a provisioned phone leave the meeting
     * @param {Object} options
     * @param {String} options.locusUrl
     * @param {String} options.phoneUrl
     * @param {String} options.correlationId
     * @param {String} options.selfId
     * @returns {Promise}
     * @private
     */
  }, {
    key: "disconnectPhoneAudio",
    value: function disconnectPhoneAudio(_ref5) {
      var locusUrl = _ref5.locusUrl,
        phoneUrl = _ref5.phoneUrl,
        correlationId = _ref5.correlationId,
        selfId = _ref5.selfId;
      _loggerProxy.default.logger.info("Meeting:request#disconnectPhoneAudio --> request phone ".concat(phoneUrl, " to leave"), correlationId);
      var uri = "".concat(locusUrl, "/").concat(_constants.PARTICIPANT, "/").concat(selfId, "/").concat(_constants.LEAVE);
      var body = {
        device: {
          deviceType: _common.deviceType.PROVISIONAL,
          url: phoneUrl
        },
        correlationId: correlationId
      };

      // @ts-ignore
      return this.locusDeltaRequest({
        method: _constants.HTTP_VERBS.PUT,
        uri: uri,
        body: body
      }).catch(function (err) {
        _loggerProxy.default.logger.error("Meeting:request#disconnectPhoneAudio --> Error when requesting phone ".concat(phoneUrl, " to leave, error ").concat(err));
        throw err;
      });
    }

    /**
     * Prepares request options to to leave a meeting
     * @param {Object} options
     * @param {Url} options.locusUrl
     * @param {String} options.selfId
     * @param {Url} options.deviceUrl
     * @param {String} options.resourceId,
     * @param {String} options.correlationId
     * @returns {Object} request options
     */
  }, {
    key: "prepareLeaveMeetingRequestOptions",
    value: function prepareLeaveMeetingRequestOptions(_ref6) {
      var locusUrl = _ref6.locusUrl,
        selfId = _ref6.selfId,
        url = _ref6.deviceUrl,
        resourceId = _ref6.resourceId,
        correlationId = _ref6.correlationId;
      var uri = "".concat(locusUrl, "/").concat(_constants.PARTICIPANT, "/").concat(selfId, "/").concat(_constants.LEAVE);
      var body = {
        device: {
          // @ts-ignore
          deviceType: this.config.meetings.deviceType,
          url: url
        },
        usingResource: resourceId || null,
        correlationId: correlationId
      };
      return {
        method: _constants.HTTP_VERBS.PUT,
        uri: uri,
        body: body
      };
    }

    /**
     * Make a network request to leave a meeting
     * @param {Object} options
     * @returns {Promise}
     */
  }, {
    key: "leaveMeeting",
    value: function leaveMeeting(_ref7) {
      var locusUrl = _ref7.locusUrl,
        selfId = _ref7.selfId,
        url = _ref7.deviceUrl,
        resourceId = _ref7.resourceId,
        correlationId = _ref7.correlationId;
      _loggerProxy.default.logger.info('Meeting:request#leaveMeeting --> Leaving a meeting', correlationId);
      var uri = "".concat(locusUrl, "/").concat(_constants.PARTICIPANT, "/").concat(selfId, "/").concat(_constants.LEAVE);
      var body = {
        device: {
          // @ts-ignore
          deviceType: this.config.meetings.deviceType,
          url: url
        },
        usingResource: resourceId || null,
        correlationId: correlationId
      };
      return this.locusDeltaRequest({
        method: _constants.HTTP_VERBS.PUT,
        uri: uri,
        body: body
      });
    }

    /**
     * Builds request options to leave a meeting
     * @param {Object} options
     * @returns {Object} request options
     */
  }, {
    key: "buildLeaveMeetingRequestOptions",
    value: function buildLeaveMeetingRequestOptions(options) {
      return this.buildLocusDeltaRequestOptions(this.prepareLeaveMeetingRequestOptions(options));
    }

    /**
     * Make a network request to acknowledge a meeting
     * @param {Object} options
     * @param {String} options.locusUrl
     * @param {String} options.deviceUrl
     * @param {String} options.correlationId
     * @returns {Promise}
     */
  }, {
    key: "acknowledgeMeeting",
    value: function acknowledgeMeeting(options) {
      var uri = "".concat(options.locusUrl, "/").concat(_constants.PARTICIPANT, "/").concat(_constants.ALERT);
      var body = {
        device: {
          // @ts-ignore
          deviceType: this.config.meetings.deviceType,
          url: options.deviceUrl
        },
        correlationId: options.correlationId
      };
      return this.locusDeltaRequest({
        method: _constants.HTTP_VERBS.PUT,
        uri: uri,
        body: body
      });
    }

    /**
     * Makes a network request to lock the meeting
     * @param {Object} options
     * @param {Boolean} options.lock Whether it is locked or not
     * @returns {Promise}
     */
  }, {
    key: "lockMeeting",
    value: function lockMeeting(options) {
      var uri = "".concat(options.locusUrl, "/").concat(_constants.CONTROLS);
      var body = {
        lock: {
          locked: options.lock
        }
      };
      return this.locusDeltaRequest({
        method: _constants.HTTP_VERBS.PATCH,
        uri: uri,
        body: body
      });
    }

    /**
     * Make a network request to decline a meeting
     * @param {Object} options
     * @param {String} options.locusUrl
     * @param {String} options.deviceUrl
     * @param {String} options.reason
     * @returns {Promise}
     */
  }, {
    key: "declineMeeting",
    value: function declineMeeting(options) {
      var uri = "".concat(options.locusUrl, "/").concat(_constants.PARTICIPANT, "/").concat(_constants.DECLINE);
      var body = _objectSpread({
        device: {
          // @ts-ignore
          deviceType: this.config.meetings.deviceType,
          url: options.deviceUrl
        }
      }, options.reason && {
        reason: options.reason
      });
      return this.locusDeltaRequest({
        method: _constants.HTTP_VERBS.PUT,
        uri: uri,
        body: body
      });
    }

    /**
     * change the content floor grant
     * @param {Object} options options for floor grant
     * @param {String} options.disposition floor action (granted/released)
     * @param {String} options.personUrl personUrl who is requesting floor
     * @param {String} options.deviceUrl Url of a device
     * @param {String} options.resourceId Populated if you are paired to a device
     * @param {String} options.uri floor grant uri
     * @param {String} options.shareInstanceId id for current share
     * @returns {Promise}
     */
  }, {
    key: "changeMeetingFloor",
    value: function changeMeetingFloor(options) {
      var floorReq = {
        disposition: options.disposition
      };

      /* istanbul ignore else */
      if (options.disposition === _constants.FLOOR_ACTION.GRANTED) {
        floorReq = {
          beneficiary: {
            url: options.personUrl,
            devices: [{
              // @ts-ignore
              deviceType: this.config.meetings.deviceType,
              url: options.deviceUrl
            }]
          },
          disposition: options.disposition,
          requester: {
            url: options.personUrl
          }
        };
      }
      var body = {
        floor: floorReq,
        resourceUrl: options.resourceUrl
      };
      if (options !== null && options !== void 0 && options.shareInstanceId) {
        body.floor.shareInstanceId = options.shareInstanceId;
      }
      if (options !== null && options !== void 0 && options.resourceToken) {
        body.resourceToken = options === null || options === void 0 ? void 0 : options.resourceToken;
      }
      if (options !== null && options !== void 0 && options.annotationInfo) {
        body.annotation = options === null || options === void 0 ? void 0 : options.annotationInfo;
      }

      // @ts-ignore
      return this.request({
        uri: options.uri,
        method: _constants.HTTP_VERBS.PUT,
        body: body
      });
    }

    /**
     * Sends a request to the DTMF endpoint to send tones
     * @param {Object} options
     * @param {String} options.locusUrl
     * @param {String} options.deviceUrl
     * @param {String} options.tones a string of one or more DTMF tones to send
     * @returns {Promise}
     */
  }, {
    key: "sendDTMF",
    value: function sendDTMF(_ref8) {
      var locusUrl = _ref8.locusUrl,
        deviceUrl = _ref8.deviceUrl,
        tones = _ref8.tones;
      // @ts-ignore
      return this.locusDeltaRequest({
        method: _constants.HTTP_VERBS.POST,
        uri: "".concat(locusUrl, "/").concat(_constants.SEND_DTMF_ENDPOINT),
        body: {
          deviceUrl: deviceUrl,
          dtmf: {
            correlationId: _uuid.default.v4(),
            tones: tones
          }
        }
      });
    }

    /**
     * Sends a request to the controls endpoint to set the video layout
     * @param {Object} options
     * @param {String} options.locusUrl
     * @param {String} options.deviceUrl
     * @param {String} options.layoutType a layout type that should be available in meeting constants {@link #layout_types}
     * @param {Object} options.main preferred dimensions for the remote main video stream
     * @param {Number} options.main.width preferred width of main video stream
     * @param {Number} options.main.height preferred height of main video stream
     * @param {Object} options.content preferred dimensions for the remote content share stream
     * @param {Number} options.content.width preferred width of content share stream
     * @param {Number} options.content.height preferred height of content share stream
     * @returns {Promise}
     */
  }, {
    key: "changeVideoLayout",
    value: function changeVideoLayout(_ref9) {
      var locusUrl = _ref9.locusUrl,
        deviceUrl = _ref9.deviceUrl,
        layoutType = _ref9.layoutType,
        main = _ref9.main,
        content = _ref9.content;
      // send main/content renderInfo only if both width and height are specified
      if (main && (!main.width || !main.height)) {
        return _promise.default.reject(new Error("Both width and height must be specified. One of them is missing for main: ".concat((0, _stringify.default)(main))));
      }
      if (content && (!content.width || !content.height)) {
        return _promise.default.reject(new Error("Both width and height must be specified. One of them is missing for content: ".concat((0, _stringify.default)(content))));
      }
      var renderInfoMain = main ? {
        width: main.width,
        height: main.height
      } : undefined;
      var renderInfoContent = content ? {
        width: content.width,
        height: content.height
      } : undefined;
      var layoutParams = renderInfoMain || renderInfoContent ? {
        renderInfo: {
          main: renderInfoMain,
          content: renderInfoContent
        }
      } : undefined;

      // @ts-ignore
      return this.locusDeltaRequest({
        method: _constants.HTTP_VERBS.PUT,
        uri: "".concat(locusUrl, "/").concat(_constants.CONTROLS),
        body: {
          layout: {
            deviceUrl: deviceUrl,
            type: layoutType,
            layoutParams: layoutParams
          }
        }
      });
    }

    /**
     * Make a network request to end meeting for all
     * @param {Object} options
     * @param {Url} options.locusUrl
     * @returns {Promise}
     */
  }, {
    key: "endMeetingForAll",
    value: function endMeetingForAll(_ref10) {
      var locusUrl = _ref10.locusUrl;
      var uri = "".concat(locusUrl, "/").concat(_constants.END);

      // @ts-ignore
      return this.locusDeltaRequest({
        method: _constants.HTTP_VERBS.POST,
        uri: uri
      });
    }

    /**
     * Send a locus keepAlive (used in lobby)
     * @param {Object} options
     * @param {Url} options.keepAliveUrl
     * @returns {Promise}
     */
  }, {
    key: "keepAlive",
    value: function keepAlive(_ref11) {
      var keepAliveUrl = _ref11.keepAliveUrl;
      // @ts-ignore
      return this.request({
        method: _constants.HTTP_VERBS.GET,
        uri: keepAliveUrl
      });
    }

    /**
     * Make a network request to send a reaction.
     * @param {Object} options
     * @param {Url} options.reactionChannelUrl
     * @param {Reaction} options.reaction
     * @param {string} options.senderID
     * @returns {Promise}
     */
  }, {
    key: "sendReaction",
    value: function sendReaction(_ref12) {
      var reactionChannelUrl = _ref12.reactionChannelUrl,
        reaction = _ref12.reaction,
        participantId = _ref12.participantId;
      var uri = reactionChannelUrl;

      // @ts-ignore
      return this.request({
        method: _constants.HTTP_VERBS.POST,
        uri: uri,
        body: {
          sender: {
            participantId: participantId
          },
          reaction: reaction
        }
      });
    }

    /**
     * Make a network request to enable or disable reactions.
     * @param {boolean} options.enable - determines if we need to enable or disable.
     * @param {locusUrl} options.locusUrl
     * @returns {Promise}
     */
  }, {
    key: "toggleReactions",
    value: function toggleReactions(_ref13) {
      var enable = _ref13.enable,
        locusUrl = _ref13.locusUrl,
        requestingParticipantId = _ref13.requestingParticipantId;
      var uri = "".concat(locusUrl, "/").concat(_constants.CONTROLS);

      // @ts-ignore
      return this.locusDeltaRequest({
        method: _constants.HTTP_VERBS.PUT,
        uri: uri,
        body: {
          reactions: {
            enabled: enable
          },
          requestingParticipantId: requestingParticipantId
        }
      });
    }
  }, {
    key: "getLocusStatusByUrl",
    value: function getLocusStatusByUrl(locusUrl) {
      // @ts-ignore
      return this.request({
        method: _constants.HTTP_VERBS.GET,
        uri: locusUrl
      });
    }

    /**
     * Sends a request to set be right back status.
     *
     * @param {Object} options - The options for brb request.
     * @param {boolean} options.enabled - Whether brb status is enabled.
     * @param {string} options.locusUrl - The URL of the locus.
     * @param {string} options.deviceUrl - The URL of the device.
     * @param {string} options.selfId - The ID of the participant.
     * @returns {Promise}
     */
  }, {
    key: "setBrb",
    value: function setBrb(_ref14) {
      var enabled = _ref14.enabled,
        locusUrl = _ref14.locusUrl,
        deviceUrl = _ref14.deviceUrl,
        selfId = _ref14.selfId;
      var uri = "".concat(locusUrl, "/").concat(_constants.PARTICIPANT, "/").concat(selfId, "/").concat(_constants.CONTROLS);
      return this.locusDeltaRequest({
        method: _constants.HTTP_VERBS.PATCH,
        uri: uri,
        body: {
          brb: {
            enabled: enabled,
            deviceUrl: deviceUrl
          }
        }
      });
    }
  }]);
  return MeetingRequest;
}(_webexCore.StatelessWebexPlugin);
//# sourceMappingURL=request.js.map
